import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    orderListData:[],   //盒子列表
  
  },
  getters: {

  },
  mutations: {

    orderList(state, data) {
      state.orderListData = data;
    }
  },
  actions: {
    //订单列表
    getBoxListA({ commit }, data) {
      api.getBoxList(data).then(res => {
        console.log("盒子列表", res)
        if (!res.code) {
           commit('orderList', res.data);
        }
      });
    },

  }
};
appStore.registerModule('magicBox', store);
